<template>
  <div class="container">
    <router-view
      v-if="ready"
      :moduleName="tplName"
      :actCode="code"
      @reportEvent="handleReport"
    ></router-view>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import tokenIn from '@/components/mixins/tokenIn';
import { getUrlParam } from '@/utils';
export default {
  data() {
    return {
      text: '',
      ready: false,
      isFromShare: getUrlParam('fromShare') ? 1 : 0
    };
  },
  mixins: [tokenIn],
  computed: {
    ...mapState('app', ['tplName', 'code'])
  },
  methods: {
    ...mapActions('app', ['loadLocationData']),
    handleReport(data) {
      const { event, ...fields } = data;
      this.visitLog('', '', {
        actEventType: event,
        activity_id: this.code,
        is_share_link: this.isFromShare,
        ...fields
      });
    }
  },
  async created() {
    await this.needLogin();
    await this.loadLocationData();
    this.ready = true;
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
}
</style>
